<div class="config-item">
  <div class="config-input-container custom-mat-form-field">
    <div class="config-label-container" style="width: 200px">
      <label class="config-label">{{ label }}</label>
    </div>
    <mat-form-field style="width: 120px" appearance="outline" class="config-input">
      <input
        matInput
        type="number"
        #inputNumber
        ngDefaultControl
        [(ngModel)]="value"
        (ngModelChange)="onValueChange($event)"
        [min]="min != undefined ? min : undefined"
        [max]="max != undefined ? max : undefined"
        [step]="step != undefined ? step : undefined"
        [placeholder]="min != undefined ? min.toString() : ''"
        [disabled]="disabled"
      />
      <span class="config-input-unit">{{ unit }}</span>
      <div class="config-input-buttons">
        <mat-spinner diameter="10" *ngIf="disabled"></mat-spinner>
        <div *ngIf="!disabled">
          <button
            #upButton
            class="config-input-button-up"
            type="button"
            (click)="incrementValue()"
            (mousedown)="startIncrementing()"
            (mouseup)="stopIncrementing()"
            (mouseleave)="stopIncrementing()"
            [disabled]="disabled"
          >
            <mat-icon class="input-arrows-style" color="#2F384B">keyboard_arrow_up</mat-icon>
          </button>
          <button
            #downButton
            class="config-input-button-down"
            type="button"
            (click)="decrementValue()"
            (mousedown)="startDecrementing()"
            (mouseup)="stopDecrementing()"
            (mouseleave)="stopDecrementing()"
            [disabled]="disabled"
          >
            <mat-icon class="input-arrows-style" color="#2F384B">keyboard_arrow_down</mat-icon>
          </button>
        </div>
      </div>
    </mat-form-field>
    <mat-icon class="info-icon" matTooltip="{{ tooltip }}">info</mat-icon>
  </div>
</div>
